// Shared component styles. Preserve selector order, style values, and caller overrides.
export const figmaIconStyles = {
  root: ({
    dimension,
    color,
    assets,
    name,
    sx
  }) => [{
    display: "inline-block",
    flexShrink: 0,
    width: dimension,
    height: dimension,
    color,
    backgroundColor: "currentColor",
    maskImage: `url("${assets[name]}")`,
    WebkitMaskImage: `url("${assets[name]}")`,
    maskSize: "contain",
    WebkitMaskSize: "contain",
    maskRepeat: "no-repeat",
    WebkitMaskRepeat: "no-repeat",
    maskPosition: "center",
    WebkitMaskPosition: "center",
    verticalAlign: "middle"
  }, sx]
};
